/* Cart requests only: one mutation, server-rendered sections, read-only recovery. */
(() => {
  'use strict';
  const failure = (code) => Object.assign(new Error(code), { code });
  const groups = window.PFCartLineGroups;
  if (!groups) throw new Error('Cart line groups must load before the page API');
  const validateCart = (cart, currency) => {
    if (!cart || cart.currency !== currency || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0 || !Array.isArray(cart.items)) throw failure('invalid-cart');
    const keys = new Set();
    for (const item of cart.items) {
      if (typeof item.key !== 'string' || !item.key || keys.has(item.key) || !Number.isSafeInteger(item.quantity) || item.quantity < 1) throw failure('invalid-cart');
      keys.add(item.key);
    }
    return cart;
  };
  const create = ({ root, sectionId, currency, fetchImpl = window.fetch.bind(window), timeout = 20000 }) => {
    if (!['/', '/en-us/'].includes(root) || !/^[\w-]+$/.test(sectionId) || !['GBP', 'USD'].includes(currency)) throw failure('invalid-context');
    const request = async (url, options = {}) => {
      const abort = new AbortController();
      const timer = setTimeout(() => abort.abort(), timeout);
      try {
        const response = await fetchImpl(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: abort.signal });
        if (!response.ok) throw failure('request-failed');
        return await response.json();
      } finally { clearTimeout(timer); }
    };
    const readCart = async () => validateCart(await request(root + 'cart.js', { headers: { Accept: 'application/json' } }), currency);
    const read = async () => {
      const cart = await readCart();
      const sections = await request(root + 'cart?sections=' + encodeURIComponent(sectionId), { headers: { Accept: 'application/json' } });
      return { cart, html: sections?.[sectionId] };
    };
    const update = async (key, quantity) => {
      const before = await readCart();
      const group = groups.groupUpdate(before, key, quantity);
      try {
        const cart = validateCart(await request(root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: group.updates, sections: [sectionId], sections_url: root + 'cart' }),
        }), currency);
        return { cart, html: cart.sections?.[sectionId], metadata: group.metadata };
      } catch (error) {
        // A timeout, HTTP error, or absent section cannot prove the write failed.
        error.submitted = true;
        throw error;
      }
    };
    return Object.freeze({ read, update });
  };
  window.PFCartPageAPI = Object.freeze({ create, validateCart, groupUpdate: groups.groupUpdate, visibleItems: groups.visibleItems });
})();
